export default __webpack_public_path__ + "6aa12503714009ebdcfa2d39344eed8e.svg";